import type {App as VueApp} from '@vue/runtime-core';
import {moveSelection} from '@/ts/directives/move-selection';
import {clickOutside} from '@/ts/directives/click-outside';
import {safeHtml} from '@/ts/directives/safe-html';

/** Registers global Vue directives (validity, move-selection, click-outside, safe-html) on the app instance */
export function addDirectives(vue: VueApp): VueApp {
  vue.directive('validity', (el: HTMLElement, binding: {value: string}) => {
    (el as HTMLInputElement).setCustomValidity(binding.value);
  });
  vue.directive('move-selection', moveSelection);
  vue.directive('click-outside', clickOutside);
  vue.directive('safe-html', safeHtml);
  return vue;
}
